import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { popupActions } from '../../store/popupStore';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import './basicInfoLink.scss';

class BasicInfoLink extends React.Component {
    state = {
        isAddress: false
    }

    render() {
        if (isNullOrUndefined(this.props.entityId))
            return null;
        return (
            <React.Fragment>
                <Link 
                    className={classnames('bi-label', {'is-normal': localStorage.locales_url_format === 'normal'})} onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()} 
                    to={`/report/quick${this.state.isAddress ? '-address' : ''}/${this.props.entityId}`} title={this.props.title}
                    style={this.props.style}
                >
                    {this.props.children}
                </Link>
            </React.Fragment>
        )
    }

    componentDidMount() {
        if (this.props.isAddress === true)
            this.setState({ isAddress: true });
    }
}

export default withLocalize(connect(
    state => state.popup,
    dispatch => bindActionCreators(popupActions, dispatch)
)(BasicInfoLink));